import BoilerPlateForm from "./BoilerPlateForm";

export default BoilerPlateForm;